<div class="modal-body">
  <div id="modal-header-wrapper">
    <h2 id="title-text">Code Option</h2>
    <p id="subtitle-text">Vous disposez d'un code pour l'option <span class="option-label">{{codedFeature.label}}</span> ? Veuillez saisir ce code afin d'obtenir la souscription à cette option...</p>

    <div id="coupon-form" class="form-field">
      <label>Code pour l'option : {{codedFeature.label}}</label>
      <input [(ngModel)]="code" type="text" class="form-control" id="code-input">
    </div>
    <small *ngIf="error" class="danger">{{error}}</small>

  </div>
  <div class="modal-footer">
    <button id="cancel-button" (click)="hideModal();" type="button"
            class="btn btn-outline-primary btn-outline text-only">
      Annuler
    </button>

    <button id="validate-button" [disabled]="!enableValidate()" (click)="validate()" type="button"
            class="btn btn-primary btn-gradient">
      Valider
    </button>
  </div>
</div>
